export * from "ce/pages/AdminSettings/WithSuperUserHoc";
import { default as CE_WithSuperUserHOC } from "ce/pages/AdminSettings/WithSuperUserHoc";
export default CE_WithSuperUserHOC;
